import type OptionPlanPrice from '../plan/option_plan_price';

export const hasOptionPlan = (
  currentOptionPlanPrices: OptionPlanPrice[] | undefined,
  optionPlanName: string
): boolean => {
  return !!currentOptionPlanPrices?.some(price => price.optionPlan.name === optionPlanName);
};
